// src/components/testingMode/TestingModeBanner.tsx
// Persistent banner shown when testing mode is active.
// Reads from meta.testingMode (authoritative source from switch-context).

import { FlaskConical } from 'lucide-react';
import { useAppSelector } from '../../store/store';
import { selectBootMeta } from '../../store/slices/bootContextSlice';
import { getCrmRoleForCentralRole, type CentralRole } from '@levelup/crm-roles';

export function TestingModeBanner() {
  const meta = useAppSelector(selectBootMeta);
  const testingMode = meta?.testingMode;

  if (!testingMode?.active) return null;

  const override = testingMode.override;
  const parts: string[] = [];
  if (override?.appName) parts.push(override.appName);
  if (override?.role) {
    // Show CRM-friendly role label instead of raw Central role
    const crmRole = getCrmRoleForCentralRole(
      override.role as CentralRole,
      (override as Record<string, unknown>).capabilityPreset as string | undefined,
    );
    parts.push(crmRole.label);
  }
  if (override?.workspaceName) parts.push(override.workspaceName);

  return (
    <div className="bg-amber-500 text-amber-950 px-4 py-1.5 text-sm font-medium flex items-center justify-center gap-2">
      <FlaskConical className="w-4 h-4" />
      <span>
        Testing Mode Active
        {parts.length > 0 && ` — ${parts.join(' / ')}`}
      </span>
    </div>
  );
}

export default TestingModeBanner;
